module.exports = __webpack_public_path__ + "static/media/team.fedaaba6.svg";